export default {
  summary: (s) => s.summary,
  selectedEntity: (s) => s.selectedEntity,
  entries: (s) => s.entries,
  pagination: (s) => s.pagination,
  balance: (s) => s.balance,
  categories: (s) => s.categories,
};
